import { COACH_ROUTE_INDEX } from '~/constants/routes/coach';
import { UNIFIED_ROUTE_LOGIN, UNIFIED_ROUTE_ONBOARDING } from '~/constants/routes/unified';
import { APP_TYPE } from '~/types/appConfig';

const EXEMPT_PATHS = [
  UNIFIED_ROUTE_LOGIN,
];

export default defineNuxtRouteMiddleware(async (to) => {
  const platformAppConfig = usePlatformAppConfig(to.path);

  if (platformAppConfig.appType !== APP_TYPE.UNIFIED) {
    return;
  }

  if (EXEMPT_PATHS.some(p => to.path.startsWith(p))) {
    return;
  }

  const { user, isGhostStudent } = useAuth();

  if (!user.value || isGhostStudent.value) {
    return;
  }

  if (user.value.unifiedOnboardingComplete && to.path === UNIFIED_ROUTE_ONBOARDING) {
    return await navigateTo(clusterRedirectPath(COACH_ROUTE_INDEX), { replace: true });
  }
});
